import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=3622bf2e"
import script from "./context-menu.vue?vue&type=script&lang=js"
export * from "./context-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports